/** @format */

import moment from "moment";
import {
  TIntermittentCommunication,
  TIntermittentStatus,
  TIntermittentWorkerType,
} from "../../../redux-modules/declarations/maps/intermittentCommunications";
import { TNextStepTone } from "./constants";

/**
 * Grafica della vista nel refactor: stessi colori di stato di Turni e Presenze (theme/maps/StatiPresenze).
 * La logica (etichette, azioni, prossimo passo) resta in constants.tsx, uguale alla produzione.
 */

/** Tono della pillola di stato: rosso = da gestire subito, ambra = da tenere d'occhio. */
export type TTono = "rosso" | "ambra" | "blu" | "azzurro" | "verde" | "grigio";

export const TONO_STATO: Record<TIntermittentStatus, TTono> = {
  scheduled: "blu",
  blocked: "rosso",
  needs_confirmation: "ambra",
  excluded: "grigio",
  sending: "blu",
  sent: "azzurro",
  worked: "verde",
  cancellation_pending: "ambra",
  cancelling: "blu",
  cancelled: "grigio",
  void: "grigio",
  expired: "rosso",
  failed: "rosso",
  uncertain: "ambra",
  deadline_missed: "rosso",
};

/** Tono del testo "Prossimo passo" (stessi toni di constants.nextStep). */
export const CLASSE_PASSO: Record<TNextStepTone, string> = {
  danger: "passo rosso",
  warning: "passo ambra",
  default: "passo",
  secondary: "passo attenuato",
};

export const ETICHETTA_TIPOLOGIA: Record<TIntermittentWorkerType, string> = {
  intermittente: "Intermittente",
  occasionale: "Occasionale",
};

/** "Oggi, lunedì 2 novembre", "Domani, ...", "Ieri, ...", "Venerdì 30 ottobre". */
export const etichettaGiorno = (data: string, oggi: string): string => {
  const testo = moment(data).format("dddd D MMMM");
  const anno = moment(data).year() !== moment(oggi).year() ? ` ${moment(data).year()}` : "";
  if (data === oggi) return `Oggi, ${testo}`;
  if (data === moment(oggi).add(1, "day").format("YYYY-MM-DD")) return `Domani, ${testo}`;
  if (data === moment(oggi).subtract(1, "day").format("YYYY-MM-DD")) return `Ieri, ${testo}`;
  return maiuscola(testo) + anno;
};

export const maiuscola = (testo: string): string =>
  testo ? testo.charAt(0).toUpperCase() + testo.slice(1) : testo;

/** "08:00–14:00" */
export const orario = (
  c: Pick<TIntermittentCommunication, "shift_start_at" | "shift_end_at">,
): string => `${moment(c.shift_start_at).format("HH:mm")}–${moment(c.shift_end_at).format("HH:mm")}`;

/** Persona nel formato delle altre viste (cognome e nome), per avatar e ricerca. */
export const persona = (
  c: TIntermittentCommunication,
): { nome: string; cognome: string; avatar: null } => ({
  nome: c.user_name ?? c.user?.name ?? "",
  cognome: c.user_surname ?? c.user?.surname ?? "",
  avatar: null,
});

export const plurale = (n: number, uno: string, molti: string): string =>
  `${n} ${n === 1 ? uno : molti}`;
